/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
import { AsyncResult } from '@msdyn365-commerce/retail-proxy';

import { ICategoryPromotionalContentData } from './hei-navigation-menu.props.autogenerated';

export interface IHeiNavigationMenuData {
    categories: AsyncResult<CategoryHierarchy[]>;
}

export interface IMenuItemData {
    id?: number;
    linkText?: string;
    linkURL?: string;
    imageSource?: string;
    imageDestinationURL?: string;
    subMenu?: IMenuItemData[];
    promotionalContent?: ICategoryPromotionalContentData[];
    menuSource?: string;
    shouldOpenNewTab?: boolean;
    ariaLabel?: string;
}

/**
 *
 * Menu type index id.
 */
export enum MenuTypeIndexId {
    Cms = 1000,
    Retail = 5000
}

/**
 *
 * Menu type source.
 */
export enum MenuSource {
    Cms = 'Cms',
    Retail = 'Retail'
}
